import { FlatTeamSettingsSchema } from "@redotech/redo-settings-common/flat-team-settings";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { omitRetiredAiTicketVolume } from "./omit-retired-ai-ticket-volume";

export const getPickedSettings = unaryRpc({
  name: "getPickedSettings",
  input: z.object({
    teamId: zExt.objectId(),
    keys: z.preprocess(
      omitRetiredAiTicketVolume,
      z.partialRecord(z.keyof(FlatTeamSettingsSchema), z.literal(1)),
    ),
  }),
  output: z.object({ settings: z.unknown() }),
});
